import { render, staticRenderFns } from "./inputSearchRoom.vue?vue&type=template&id=645fd7a0&scoped=true"
import script from "./inputSearchRoom.vue?vue&type=script&lang=js"
export * from "./inputSearchRoom.vue?vue&type=script&lang=js"
import style0 from "./inputSearchRoom.vue?vue&type=style&index=0&id=645fd7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645fd7a0",
  null
  
)

export default component.exports